"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTooltipShownAfterMainPrice = exports.isTooltipShownAfterListPrice = exports.isAdditionalTextShown = exports.getTwoYearTermListPriceDisplay = exports.getPriceTooltipMsg = exports.getPremiumRenewalPriceText = exports.getMultiYearTermCurrentPriceDisplay = exports.getListPriceDisplayForPriceBlockType = exports.getFinalListPriceDisplay = exports.getFinalCurrentPriceDisplay = exports.getCurrentPriceDisplayForPriceBlockType = exports.getAdditionalTextAndToolTipComponent = exports.getAdditionalPriceText = exports.getAdditionalPriceProp = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _sharedComponents = require("@site/shared-components");
var _utils = require("@site/utils");
var _styleWrapper = require("./styles/styleWrapper");
var _TooltipContent = _interopRequireDefault(require("./TooltipContent"));
const {
  PriceLabel,
  PriceDisclaimer
} = _styleWrapper.PriceStyling;
const getPriceTooltipMsg = ({
  id,
  values,
  hasIcannFee,
  icannFee,
  icannFeeMessage
}) => {
  return /*#__PURE__*/_react.default.createElement(_TooltipContent.default, {
    id,
    values,
    hasIcannFee,
    icannFee,
    icannFeeMessage
  });
};

// eslint-disable-next-line complexity
exports.getPriceTooltipMsg = getPriceTooltipMsg;
const getAdditionalPriceProp = ({
  options,
  messages,
  domain,
  product,
  formatMessage,
  samePriceEachYear,
  isPriceConsistent,
  showTwoLinePrice,
  isStackBundle,
  isPromoForNewCustomer,
  disableAdditionalTextToolTip,
  term,
  forceTermLengthOverride
}) => {
  const {
    IcannFeePrice: icannFee
  } = domain;
  const {
    PriceInfo = {},
    HasIcannFee: hasIcannFee
  } = product;
  const {
    ListPrice: listPrice,
    ListPriceDisplay: listPriceDisplay,
    CurrentPrice: currentPrice,
    CurrentPriceDisplay: currentPriceDisplay,
    RenewalPrice: renewalPrice = listPrice,
    RenewalPriceDisplay: renewalPriceDisplay = listPrice,
    IsPromoDiscount,
    PromoRegLengthFlag,
    PromoRestrictions
  } = PriceInfo;
  const hasPromo = IsPromoDiscount && PromoRegLengthFlag >= 2;
  const hasSinglePurchasePromoRestriction = PromoRestrictions?.some(r => r.Type === 'SinglePurchase');
  const hasSingleItemPromoRestriction = PromoRestrictions?.some(r => r.Type === 'MaxAllowedQuantity' && r.MaxQuantity === 1);
  const isAuctionOrAftermarketPremium = (0, _utils.isAuction)(domain) || (0, _utils.isAftermarketPremium)(domain);
  const values = {
    minimumTermLength: PromoRegLengthFlag,
    additionalYearPrice: renewalPriceDisplay,
    renewalPrice: renewalPriceDisplay,
    price: currentPriceDisplay,
    listPrice: listPriceDisplay
  };
  const tooltipValues = {
    values,
    hasIcannFee,
    icannFee,
    icannFeeMessage: messages.icannFee
  };
  const {
    displayPercentagePrice = false
  } = options;
  const finalTerm = (0, _utils.calculateFinalTermDisplay)(term, PriceInfo, forceTermLengthOverride);
  const multiYearTermDisplay = (0, _utils.getMultiYearFirstYearSalePriceDisplay)(term, PriceInfo);
  const yearTerm = (0, _utils.convertMonthlyTermToYearTerm)(term);
  switch (true) {
    case finalTerm > 1 && (!!multiYearTermDisplay || forceTermLengthOverride):
      return {
        priceAdditionalText: formatMessage({
          id: messages.termsWithMin
        }, {
          numYears: yearTerm
        }),
        priceToolTipMsg: getPriceTooltipMsg({
          id: messages.firstYearDiscountWithTerm,
          ...tooltipValues,
          values: {
            ...values,
            minimumTermLength: yearTerm
          }
        })
      };
    case finalTerm === 1 && !!multiYearTermDisplay:
      return {
        priceAdditionalText: formatMessage({
          id: messages.termsNoMin
        }),
        priceToolTipMsg: renewalPrice > currentPrice ? getPriceTooltipMsg({
          id: messages.firstYearDiscount,
          ...tooltipValues
        }) : null
      };
    case samePriceEachYear && !showTwoLinePrice && isPriceConsistent && !hasIcannFee:
      return {
        priceAdditionalText: null,
        priceToolTipMsg: null
      };
    case disableAdditionalTextToolTip:
      return {
        priceToolTipMsg: null
      };
    case samePriceEachYear && !showTwoLinePrice:
      return {
        priceAdditionalText: null,
        priceToolTipMsg: getPriceTooltipMsg({
          id: messages.samePriceEachYear,
          ...tooltipValues
        })
      };
    case isPromoForNewCustomer && hasSinglePurchasePromoRestriction && hasSingleItemPromoRestriction:
      return {
        priceAdditionalText: formatMessage({
          id: messages.termsNoMin
        }),
        priceToolTipMsg: getPriceTooltipMsg({
          id: messages.newShopperPromo,
          ...tooltipValues
        })
      };
    case hasPromo && !isAuctionOrAftermarketPremium:
      return {
        priceAdditionalText: formatMessage({
          id: messages.termsWithMin
        }, {
          numYears: PromoRegLengthFlag
        }),
        priceToolTipMsg: getPriceTooltipMsg({
          id: messages.firstYearDiscountWithTerm,
          ...tooltipValues
        })
      };
    case isAuctionOrAftermarketPremium:
      if (renewalPriceDisplay) {
        return {
          priceAdditionalText: formatMessage({
            id: listPrice !== renewalPrice ? messages.whenYouRenew : messages.plusRenewal
          }, {
            yearlyPrice: renewalPriceDisplay
          }),
          priceToolTipMsg: getPriceTooltipMsg({
            id: messages.premium,
            ...tooltipValues
          })
        };
      }
      return {
        priceAdditionalText: '',
        priceToolTipMsg: ''
      };
    case isStackBundle:
      return {
        priceAdditionalText: !displayPercentagePrice && formatMessage({
          id: messages.termsNoMin
        }),
        priceToolTipMsg: getPriceTooltipMsg({
          id: messages.firstYearDiscountBundle,
          ...tooltipValues
        })
      };
    case renewalPrice === currentPrice:
      return {
        priceAdditionalText: formatMessage({
          id: messages.termsNoFirstYrDiscNoPromo
        }),
        priceToolTipMsg: getPriceTooltipMsg({
          id: messages.noDiscountTerms,
          ...tooltipValues
        })
      };
    default:
      return {
        priceAdditionalText: !displayPercentagePrice && formatMessage({
          id: messages.termsNoMin
        }),
        priceToolTipMsg: renewalPrice > currentPrice ? getPriceTooltipMsg({
          id: messages.firstYearDiscount,
          ...tooltipValues
        }) : null
      };
  }
};
exports.getAdditionalPriceProp = getAdditionalPriceProp;
const getAdditionalTextAndToolTipComponent = ({
  formatMessage,
  priceAdditionalTextOverride,
  priceToolTip,
  options,
  messages,
  domain,
  product,
  samePriceEachYear,
  isPriceConsistent,
  showTwoLinePrice,
  isStackBundle,
  isPromoForNewCustomer,
  disableAdditionalTextToolTip,
  portalElem,
  term,
  forceTermLengthOverride
}) => {
  const additionalTextOverride = typeof priceAdditionalTextOverride === 'string' ? /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _utils.sanitizeHTML)(priceAdditionalTextOverride)
    }
  }) : priceAdditionalTextOverride;
  if (additionalTextOverride && priceToolTip) {
    return {
      priceAdditionalText: additionalTextOverride,
      priceToolTipComponent: priceToolTip
    };
  }
  const {
    priceAdditionalText,
    priceToolTipMsg
  } = getAdditionalPriceProp({
    options,
    messages,
    domain,
    product,
    formatMessage,
    samePriceEachYear,
    isPriceConsistent,
    showTwoLinePrice,
    isStackBundle,
    isPromoForNewCustomer,
    disableAdditionalTextToolTip,
    term,
    forceTermLengthOverride
  });
  const toolTipComponent = /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
    stopPropagation: true,
    id: "tooltip",
    title: formatMessage({
      id: messages.pricingTitle
    }),
    tooltipContent: priceToolTipMsg,
    tooltipButtonAriaLabel: options.tooltipButtonAriaLabel,
    portalElem: portalElem
  });
  const additionalText = additionalTextOverride || priceAdditionalText;
  const toolTip = priceToolTip || toolTipComponent;
  return {
    priceAdditionalText: additionalText,
    priceToolTipComponent: toolTip
  };
};
exports.getAdditionalTextAndToolTipComponent = getAdditionalTextAndToolTipComponent;
const getAdditionalPriceText = ({
  priceAdditionalText,
  priceDisclaimer,
  styleOverrides,
  isMobile,
  isAuctionOrAftermarketPremium,
  showTwoLinePrice,
  enableDynamicFontScaling = false,
  isAftermarketPremiumDomain,
  plid
}) => {
  if (priceAdditionalText) {
    return /*#__PURE__*/_react.default.createElement(PriceDisclaimer, {
      'data-cy': 'pricing-disclaimer',
      'data-testid': 'pricing-disclaimer',
      'className': (0, _classnames.default)(`pricing-disclaimer ${priceDisclaimer}`, {
        'text-muted': !styleOverrides?.disclaimerStyle?.color && !showTwoLinePrice && (0, _utils.isReseller)(plid),
        'd-inline-block': isMobile && !isAuctionOrAftermarketPremium,
        'ms-2 mt-0': !showTwoLinePrice && !isMobile,
        'ms-3 mt-0': !showTwoLinePrice && isMobile,
        'ms0 ml-2': showTwoLinePrice,
        'pricing-disclaimer-dynamic-font-scaling': enableDynamicFontScaling,
        'ml-1': isAftermarketPremiumDomain
      }),
      'style': showTwoLinePrice ? {} : styleOverrides?.disclaimerStyle
    }, priceAdditionalText);
  }
  return null;
};
exports.getAdditionalPriceText = getAdditionalPriceText;
const getPremiumRenewalPriceText = ({
  isRegPremiumDomain,
  isAftermarketPremiumDomain,
  messages
}) => {
  if (isRegPremiumDomain) return messages.renewalText;
  if (isAftermarketPremiumDomain) return messages.plusRenewal;
  return null;
};

// Current Price
exports.getPremiumRenewalPriceText = getPremiumRenewalPriceText;
const getMultiYearTermCurrentPriceDisplay = ({
  overrideCurrentPriceToZero,
  currentPriceDisplay,
  messages,
  isFree,
  isMobile,
  mainPriceStyle
}) => {
  const freeFirstYear = /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "currentprice-multi-year-term",
    "data-testid": "currentprice-multi-year-term"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('font-weight-bold', {
      ms0: isMobile,
      ms1: !isMobile
    })
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messages.freeLabel
  })), /*#__PURE__*/_react.default.createElement(PriceLabel, {
    className: "ms0 font-weight-normal"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messages.firstYear
  })));
  const currentPriceFirstYear = /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "currentprice-multi-year-term",
    "data-testid": "currentprice-multi-year-term"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('font-weight-bold', {
      ms0: isMobile && !mainPriceStyle?.fontSize,
      ms1: !isMobile && !mainPriceStyle?.fontSize
    })
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messages.price,
    values: {
      price: currentPriceDisplay
    }
  })), /*#__PURE__*/_react.default.createElement(PriceLabel, {
    className: (0, _classnames.default)({
      'ms0': !mainPriceStyle?.fontSize,
      'font-weight-normal': !mainPriceStyle?.fontWeight
    }),
    style: {
      fontSize: mainPriceStyle?.perTermFontSize
    }
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messages.firstYear
  })));
  const showFreeFirstYear = isFree || overrideCurrentPriceToZero;
  const currentPriceMultiYearTerm = showFreeFirstYear ? freeFirstYear : currentPriceFirstYear;
  return currentPriceMultiYearTerm;
};
exports.getMultiYearTermCurrentPriceDisplay = getMultiYearTermCurrentPriceDisplay;
const getCurrentPriceDisplayForPriceBlockType = ({
  forceOneYearDisplay,
  showTwoLinePrice,
  currentPriceMultiYearTermDisplay,
  currentPriceDisplay,
  isAuctionOrAftermarketPremium,
  isMobile,
  samePriceEachYear,
  messages,
  showMultiYearTermForATMP,
  showMonthlyPriceForATMP,
  isAiroDomainPlus,
  domainAiroPlusPriceDisplay,
  term,
  PriceInfo = {},
  forceTermLengthOverride
}) => {
  const finalTerm = (0, _utils.calculateFinalTermDisplay)(term, PriceInfo, forceTermLengthOverride);
  const multiYearTermDisplay = (0, _utils.getMultiYearFirstYearSalePriceDisplay)(term, PriceInfo);
  if (finalTerm > 1 && multiYearTermDisplay) {
    return multiYearTermDisplay;
  }
  if (isAiroDomainPlus) {
    return domainAiroPlusPriceDisplay;
  }
  if (forceOneYearDisplay && multiYearTermDisplay) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-bold"
    }, multiYearTermDisplay);
  }
  if (showTwoLinePrice && isAuctionOrAftermarketPremium) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('font-weight-bold', {
        ms0: isMobile
      })
    }, currentPriceDisplay);
  }
  if (showTwoLinePrice || showMultiYearTermForATMP) {
    return currentPriceMultiYearTermDisplay;
  }
  if (samePriceEachYear && !showMonthlyPriceForATMP) {
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: messages.currentPricePerYear,
      values: {
        price: currentPriceDisplay
      }
    });
  }
  return currentPriceDisplay;
};
exports.getCurrentPriceDisplayForPriceBlockType = getCurrentPriceDisplayForPriceBlockType;
const getFinalCurrentPriceDisplay = ({
  premiumPriceDisplay,
  currentPriceDisplayOverride,
  CurrentPriceDisplay,
  messages,
  isFree,
  isAuctionOrAftermarketPremium,
  formatMessage,
  overrideCurrentPriceToZero,
  isMobile,
  OneYearSalePrice,
  OneYearSalePriceDisplay,
  forceOneYearDisplay,
  samePriceEachYear,
  showTwoLinePrice,
  mainPriceStyle,
  showMonthlyPriceForATMP,
  showMultiYearTermForATMP,
  isAiroDomainPlus,
  domainAiroPlusPriceDisplay,
  term,
  PriceInfo = {},
  forceTermLengthOverride
}) => {
  const currentPriceDisplayBase = (0, _utils.getCurrentPriceDisplay)({
    premiumPriceDisplay,
    currentPriceDisplayOverride,
    CurrentPriceDisplay,
    messages,
    isFree,
    isAuctionOrAftermarketPremium,
    showTwoLinePrice,
    formatMessage,
    showMonthlyPriceForATMP
  });
  const currentPriceMultiYearTermDisplay = getMultiYearTermCurrentPriceDisplay({
    currentPriceDisplay: currentPriceDisplayBase,
    overrideCurrentPriceToZero,
    messages,
    isFree,
    isMobile,
    mainPriceStyle
  });
  const oneYearTermPriceDisplay = (0, _utils.getOneYearTermCurrPriceDisplay)({
    currentPriceDisplay: currentPriceDisplayBase,
    OneYearSalePriceDisplay
  });
  const currentPriceDisplay = getCurrentPriceDisplayForPriceBlockType({
    currentPriceDisplay: currentPriceDisplayBase,
    forceOneYearDisplay,
    oneYearTermPriceDisplay,
    OneYearSalePrice,
    currentPriceMultiYearTermDisplay,
    showTwoLinePrice,
    isAuctionOrAftermarketPremium,
    isMobile,
    samePriceEachYear,
    messages,
    showMultiYearTermForATMP,
    showMonthlyPriceForATMP,
    isAiroDomainPlus,
    domainAiroPlusPriceDisplay,
    term,
    PriceInfo,
    forceTermLengthOverride
  });
  return currentPriceDisplay;
};

// List Price
exports.getFinalCurrentPriceDisplay = getFinalCurrentPriceDisplay;
const getTwoYearTermListPriceDisplay = ({
  listPriceDisplay,
  messages,
  isMobile
}) => {
  const listPriceTwoYearTerm = /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "listprice-two-year-term",
    "data-testid": "listprice-two-year-term",
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "two-year-term-first-year-price",
    "data-testid": "two-year-term-first-year-price",
    className: (0, _classnames.default)('font-weight-bold', {
      ms0: isMobile,
      ms1: !isMobile
    })
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messages.price,
    values: {
      price: listPriceDisplay
    }
  })), /*#__PURE__*/_react.default.createElement(PriceLabel, {
    "data-cy": "two-year-term-second-year-price",
    "data-testid": "two-year-term-second-year-price",
    className: "ms0 font-weight-normal"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: messages.secondYear
  })));
  return listPriceTwoYearTerm;
};
exports.getTwoYearTermListPriceDisplay = getTwoYearTermListPriceDisplay;
const getListPriceDisplayForPriceBlockType = ({
  samePriceEachYear,
  isPriceConsistent,
  listPriceDisplay,
  formatMessage,
  showTwoLinePrice,
  isAiroDomainPlus,
  domainAiroPlusPriceDisplay
}) => {
  if (isAiroDomainPlus) {
    return domainAiroPlusPriceDisplay;
  }
  if (showTwoLinePrice) {
    return listPriceDisplay;
  }
  if (isPriceConsistent) {
    return null;
  }
  if (samePriceEachYear && listPriceDisplay) {
    return formatMessage({
      id: 'pricing.display.price-per-year'
    }, {
      price: listPriceDisplay
    });
  }
  return listPriceDisplay;
};
exports.getListPriceDisplayForPriceBlockType = getListPriceDisplayForPriceBlockType;
const getFinalListPriceDisplay = ({
  initialPriceDisplayOverride,
  isAuctionOrAftermarketPremium,
  ListPrice,
  currentPrice,
  ListPriceDisplay,
  showTwoLinePrice,
  messages,
  isMobile,
  samePriceEachYear,
  isPriceConsistent,
  formatMessage,
  isAiroDomainPlus,
  domainAiroPlusPriceDisplay
}) => {
  const listPriceDisplayBase = (0, _utils.getListPriceDisplay)({
    initialPriceDisplayOverride,
    isAuctionOrAftermarketPremium,
    ListPrice,
    currentPrice,
    ListPriceDisplay,
    showTwoLinePrice
  });
  const listPriceTwoYearTermDisplay = getTwoYearTermListPriceDisplay({
    listPriceDisplay: listPriceDisplayBase,
    messages,
    isMobile
  });
  const listPriceDisplay = getListPriceDisplayForPriceBlockType({
    samePriceEachYear,
    isPriceConsistent,
    listPriceDisplay: listPriceDisplayBase,
    showTwoLinePrice,
    formatMessage,
    isAiroDomainPlus,
    domainAiroPlusPriceDisplay
  });
  return {
    listPriceDisplay,
    listPriceTwoYearTermDisplay
  };
};
exports.getFinalListPriceDisplay = getFinalListPriceDisplay;
const isTooltipShownAfterMainPrice = ({
  showPriceOnly,
  showTwoLinePrice,
  showListPriceTooltip,
  isMobile,
  isAuctionOrAftermarketPremium
}) => {
  if (showPriceOnly) return false;
  return !showListPriceTooltip && (!showTwoLinePrice && !isMobile || isMobile && isAuctionOrAftermarketPremium);
};
exports.isTooltipShownAfterMainPrice = isTooltipShownAfterMainPrice;
const isTooltipShownAfterListPrice = ({
  isMobile,
  isAuctionOrAftermarketPremium,
  showTwoLinePrice,
  showListPriceTooltip,
  isRegPremiumDomain
}) => {
  return !showListPriceTooltip && isMobile && !isAuctionOrAftermarketPremium && !showTwoLinePrice || showListPriceTooltip && !isRegPremiumDomain;
};
exports.isTooltipShownAfterListPrice = isTooltipShownAfterListPrice;
const isAdditionalTextShown = ({
  showPriceOnly,
  showTwoLinePrice,
  qualifiersTextId,
  showAdditionalText,
  isAuctionOrPremium
}) => {
  if (showPriceOnly) return false;
  return !showTwoLinePrice && !showAdditionalText && !qualifiersTextId || showAdditionalText && !isAuctionOrPremium;
};
exports.isAdditionalTextShown = isAdditionalTextShown;